module.exports = __webpack_public_path__ + "static/img/certify04.1130250.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/swiper/images/certify04.png
// module id = pn2i
// module chunks = 1